var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4078,
    cy: 16.1842,
    r: 16.1842,
    fill: "#F5EBFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4078 9.9541C8.45486 9.9541 8.31567 10.6613 8.31567 16.1849C8.31567 21.7085 8.45486 22.4157 16.4078 22.4157C24.3607 22.4157 24.4999 21.7085 24.4999 16.1849C24.4999 10.6613 24.3607 9.9541 16.4078 9.9541ZM19.0013 16.4552L15.3679 18.1513C15.0499 18.2985 14.7894 18.1335 14.7894 17.7823V14.5876C14.7894 14.2372 15.0499 14.0713 15.3679 14.2186L19.0013 15.9147C19.3193 16.0635 19.3193 16.3063 19.0013 16.4552Z",
    fill: "#3C1D59"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.1842,
    height: 16.184,
    fill: "white",
    transform: "translate(8.31567 8.09277)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.00b80fd50627e1796ff41ebbd5ba2414.svg";
export { ForwardRef as ReactComponent };